import { render, staticRenderFns } from "./DocumentLinkList.vue?vue&type=template&id=2a5db653&scoped=true&"
import script from "./DocumentLinkList.vue?vue&type=script&lang=js&"
export * from "./DocumentLinkList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5db653",
  null
  
)

export default component.exports